import React from 'react';
import { pageTypes } from '../../../../utils/layoutConfig';
import { FormControl, FormLabel, Input, Select } from '@chakra-ui/react';

function setPageType({ e, editPageProps, setEditPageProps, setSelectedPageType, setIsCustomType, selectedPageType }) {
	const value = e.target.value;
	const newPageInfo = { ...editPageProps };
	newPageInfo.pageType = value;
	setIsCustomType(!!(value == 'custom' || !pageTypes.find((el) => el.value == value)));
	setSelectedPageType(value);
	setEditPageProps(newPageInfo);
}

function getIsCustom(selectedPageType) {
	return selectedPageType == 'custom' || !pageTypes.find((el) => el.value == selectedPageType);
}

function handleCustomTypeOnChange({ e, editPageProps, setEditPageProps, setSelectedPageType }) {
	const value = e.target.value;
	const newPageInfo = { ...editPageProps };
	newPageInfo.pageType = value;
	setSelectedPageType(value);
	setEditPageProps(newPageInfo);
}
const customInputStyle = {
	border: 'none',
	borderBottom: '1px',
	borderRadius: '0px',
	size: 'sm',
	mt: 2,
	_focus: {
		border: 'none',
		borderBottom: '2px',
		borderColor: '#3182ce',
		boxShadow: '0 0 3px 1px #3182ce',
		borderRadius: '6px',
	},
};
const EditPageType = ({ editPageProps, setEditPageProps }) => {
	console.log(editPageProps);
	const [typeOfPages] = React.useState(pageTypes);
	const [selectedPageType, setSelectedPageType] = React.useState(editPageProps.pageType);
	const [isCustomType, setIsCustomType] = React.useState(!!getIsCustom(editPageProps.pageType));

	React.useEffect(() => {
		setSelectedPageType(editPageProps.pageType);
		setIsCustomType(!!getIsCustom(editPageProps.pageType));
	}, [editPageProps.pageType]);

	return (
		<FormControl mb={6}>
			<FormLabel fontSize={'sm'} pb={1} m={0} fontWeight={'500'}>
				Tipo da página
			</FormLabel>
			{isCustomType ? 'custom' : selectedPageType}
			{/* <Select fontSize={"sm"} onChange={(e) => setPageType({ e, editPageProps, setEditPageProps,setSelectedPageType,setIsCustomType,selectedPageType  })} value={isCustomType?"custom":selectedPageType} borderRadius={"lg"}>
                {typeOfPages.map((type, index) => {
                    return (
                        <option key={index} value={type.value}>
                            {type.name}
                        </option>
                    );
                })}
            </Select> */}
			{/* {isCustomType&&<Input {...customInputStyle} value={selectedPageType} onChange={(e)=>handleCustomTypeOnChange({ e, editPageProps, setEditPageProps,setSelectedPageType })} placeholder="Digite o tipo da página"/>} */}
		</FormControl>
	);
};

export default EditPageType;
